/** Additional options for the popup notification manager. */
export interface PopupNotificationOptions{
    disableClicking?: boolean;
}

/**
 * Close a notification pop-up when it is clicked using a mouse.
 * @param event A mouse click event.
 */
function closePopupNotification(event: MouseEvent): void{
    (<HTMLDivElement>event.target).classList.add("is-away");
}

/**
 * Manager class for displaying pop-up notifications that emerge from the top of the screen.
 * The class handles <div> elements with the Bulma "notification" class.
 */
export class PopupNotification{
    /** Length for a medium length notification in milliseconds. */
    public static readonly NOTIFICATION_LENGTH_MEDIUM = 4000;

    /** Controlled notification HTML element. */
    private readonly notificationElement: HTMLDivElement;
    private timeoutId: NodeJS.Timeout|undefined;

    /**
     * Create new popup notification manager for the given div element.
     * @param notificationElement Notification div HTML element.
     * @param options Additional options.
     */
    public constructor(notificationElement: HTMLDivElement, options: PopupNotificationOptions = {}){
        this.notificationElement = notificationElement;
        const fullOptions = {
            disableClicking: false,
            ...options
        };

        if(!fullOptions.disableClicking){
            this.notificationElement.addEventListener("click", closePopupNotification);
        }
    }

    /**
     * Display the notification pop-up and set a timeout to hide it.
     */
    public show(): void{
        this.notificationElement.classList.remove("is-away");
        clearTimeout(this.timeoutId);
        this.timeoutId = globalThis.setTimeout(() => {
            this.notificationElement.classList.add("is-away");
        }, PopupNotification.NOTIFICATION_LENGTH_MEDIUM);
    }

    /**
     * Forcefully close this notification pop-up.
     */
    public close(): void{
        clearTimeout(this.timeoutId);
        this.notificationElement.classList.add("is-away");
    }
}